import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index/index.vue')
  },
  {
    path: '/admin/login',
    name: 'login',
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '',
    name: 'layout',
    component: () => import('@/layout/layout.vue'),
    redirect: '/admin/index',
    children: [
      {
        path: "/admin/index",
        name: 'adminindex',
        component: () => import('@/views/pages/adminindex/index.vue')
      }
    ]
  },
  {
    path: '/exam/success',
    name: 'exam-finish',
    component: () => import('@/views/exam/finish.vue')
  },
  {
    path: '/exam/:id',
    name: 'exam-index',
    component: () => import('@/views/exam/index.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/error/index.vue')
  },
]

const router = new VueRouter({
  mode: "hash",
  // base:'/webadmin/',
  routes
})

export default router
